module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av335-e2721f85be385b4d723c603e7e077918.jpg";